
/* === JA — Swatches image swap === */
(function () {
  function jaSwapImage(card, imgSrc) {
    var img = card.querySelector('.grid-product__link img');
    if (img && imgSrc) {
      img.src = imgSrc;
      img.srcset = '';
    }
  }

  function jaUpdateLink(card, variantId) {
    var link = card.querySelector('.grid-product__link');
    if (!link || !variantId) return;
    var base = link.getAttribute('href').split('?')[0];
    link.setAttribute('href', base + '?variant=' + variantId);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.grid-product').forEach(function (card) {
      var active = card.querySelector('.ja-swatch--active');
      if (active && active.dataset.variantId) {
        jaUpdateLink(card, active.dataset.variantId);
      }
    });
  });

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.ja-swatch');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();
    var card = swatch.closest('.grid-product');
    if (!card) return;
    jaSwapImage(card, swatch.dataset.imgSrc);
    jaUpdateLink(card, swatch.dataset.variantId);
    card.querySelectorAll('.ja-swatch').forEach(function (b) {
      b.classList.remove('ja-swatch--active');
    });
    swatch.classList.add('ja-swatch--active');
  });

  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function (e) {
      var swatch = e.target.closest('.ja-swatch');
      if (!swatch) return;
      var card = swatch.closest('.grid-product');
      if (!card) return;
      if (!card.dataset.jaOriginalSrc) {
        var img = card.querySelector('.grid-product__link img');
        if (img) card.dataset.jaOriginalSrc = img.src;
      }
      jaSwapImage(card, swatch.dataset.imgSrc);
    });

    document.addEventListener('mouseout', function (e) {
      var swatch = e.target.closest('.ja-swatch');
      if (!swatch) return;
      var card = swatch.closest('.grid-product');
      if (!card) return;
      var active = card.querySelector('.ja-swatch--active');
      jaSwapImage(card, active ? active.dataset.imgSrc : card.dataset.jaOriginalSrc);
    });
  }
})();

document.addEventListener("DOMContentLoaded", () => {

  const joe_brand_chart_Button = document.querySelector(".joe_brand_chart_Button");
  const joe_brand_info_wrapper = document.querySelector(".joe_brand_info_wrapper");
  const joe_brand_info_closeButton = document.querySelector(".joe_brand_info_closeButton");
  const body = document.body;

  
  if (!joe_brand_chart_Button || !joe_brand_info_wrapper) return;



  joe_brand_chart_Button.addEventListener("click", () => {
    joe_brand_info_wrapper.classList.add("is-open");
    body.style.overflow="hidden";
  });


  joe_brand_info_closeButton.addEventListener("click",()=>{
    joe_brand_info_wrapper.classList.remove("is-open");
    body.style.overflow="auto";
  })


  joe_brand_info_wrapper.addEventListener("click", (event) => {

    if (event.target === joe_brand_info_wrapper) {
      joe_brand_info_wrapper.classList.remove("is-open");
      body.style.overflow = "auto";
    }
  });

});









// ---- Size chart CM / INCH toggle ----
document.addEventListener("DOMContentLoaded", () => {
  // Masquer tous les tableaux INCH au chargement (CSS ne peut pas le faire sans affecter l'éditeur admin)
  document.querySelectorAll('.sc-size-guide [data-unit-table="inch"]').forEach(t => {
    t.style.display = "none";
  });
});

document.addEventListener("click", (e) => {
  const btn = e.target.closest(".sc-unit-btn");
  if (!btn) return;
  const unit = btn.dataset.unit;
  const guide = btn.closest(".sc-size-guide");
  if (!guide) return;
  guide.querySelectorAll(".sc-unit-btn").forEach(b => b.classList.remove("active"));
  btn.classList.add("active");
  guide.querySelectorAll("[data-unit-table]").forEach(t => {
    t.style.display = t.dataset.unitTable === unit ? "" : "none";
  });
});

// three pop up ok dear --------------------------------------

(function () {
  var popup = document.getElementById('threePopup');
  var closeBtn = document.getElementById('closePopup');
  var openButtons = document.querySelectorAll('.single_popup_forCondition');
  var tax = document.querySelector(".three_popUpDiv_parent_Content_tax");
  var shipping = document.querySelector(".three_popUpDiv_parent_Content_shipping");
  var retun = document.querySelector(".three_popUpDiv_parent_Content_retun");

  if (!popup || !tax || !shipping || !retun) return;

  var popupBody = document.body;

  function hideAllContent() {
    tax.style.display = "none";
    shipping.style.display = "none";
    retun.style.display = "none";
  }

  hideAllContent();

  openButtons.forEach(function (btn, index) {
    btn.style.cursor = "pointer";
    btn.addEventListener("click", function () {
      popup.classList.add("is-open");
      popupBody.style.overflow = "hidden";
      hideAllContent();
      if (index === 0) tax.style.display = "flex";
      else if (index === 1) shipping.style.display = "flex";
      else if (index === 2) retun.style.display = "flex";
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      popup.classList.remove("is-open");
      popupBody.style.overflow = "auto";
      hideAllContent();
    });
  }

  popup.addEventListener("click", function (e) {
    if (e.target === popup) {
      popup.classList.remove("is-open");
      popupBody.style.overflow = "auto";
      hideAllContent();
    }
  });
})();




(function () {
  var getVendorClass = document.querySelector(".joe_aventure_vendorName");
  if (!getVendorClass) return;

  var getVendorName = getVendorClass.dataset.vendorname
    .toLowerCase()
    .replace(/\s+/g, "");

  getVendorClass.classList.add("textt_lowercase");

  document.querySelectorAll(".chart_all_information_child").forEach(function (element) {
    element.style.display = "none";
    element.classList.add("text_lowercase");
    var EveryBrandName_fromDataset = element.dataset.brandname
      .toLowerCase()
      .replace(/\s+/g, "");
    if (getVendorName === EveryBrandName_fromDataset) {
      element.style.display = "block";
    }
  });
})();

/* === JA — Remove leading $ from collection grid prices === */
(function () {
  function jaFixPrices() {
    document.querySelectorAll(
      '.grid-product__price span:not(.visually-hidden), .grid-product__price--original'
    ).forEach(function (el) {
      el.innerHTML = el.innerHTML.replace(/\$(?=\d)/g, '');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', jaFixPrices);
  } else {
    jaFixPrices();
  }
})();

/* === JA — Mobile nav slide panels === */
(function () {
  var stack = ['ja-panel-root'];

  function goForward(targetId) {
    var currentId = stack[stack.length - 1];
    var current = document.getElementById(currentId);
    var target = document.getElementById(targetId);
    if (!target || !current) return;
    current.classList.add('ja-panel--behind');
    current.classList.remove('ja-panel--active');
    target.classList.add('ja-panel--active');
    target.scrollTop = 0;
    stack.push(targetId);
  }

  function goBack() {
    if (stack.length <= 1) return;
    var currentId = stack.pop();
    var parentId = stack[stack.length - 1];
    var current = document.getElementById(currentId);
    var parent = document.getElementById(parentId);
    if (!current || !parent) return;
    current.classList.remove('ja-panel--active');
    parent.classList.remove('ja-panel--behind');
    parent.classList.add('ja-panel--active');
  }

  function resetNav() {
    document.querySelectorAll('.ja-panel').forEach(function (p) {
      p.classList.remove('ja-panel--active', 'ja-panel--behind');
    });
    var root = document.getElementById('ja-panel-root');
    if (root) root.classList.add('ja-panel--active');
    stack = ['ja-panel-root'];
  }

  /* Capture phase — fires before any theme stopPropagation */
  document.addEventListener('click', function (e) {
    var fwd = e.target.closest('.ja-panel-forward');
    if (fwd) { goForward(fwd.getAttribute('data-target')); return; }

    var bck = e.target.closest('.ja-panel-back');
    if (bck) { goBack(); return; }

    if (e.target.closest('.js-drawer-close') || e.target.closest('.js-drawer-overlay')) {
      setTimeout(resetNav, 350);
    }
  }, true);

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') setTimeout(resetNav, 350);
  });
})();


/* === JOE — Cart drawer free-shipping bar (live update) === */
(function () {
  var TRUCK_SVG = '<svg class="joe-fs__truck" viewBox="0 0 640 512" fill="currentColor" aria-hidden="true" focusable="false"><path d="M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32V237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"/></svg>';

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // **texte** => <strong>texte</strong>
  function boldify(str) {
    return str.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  }

  function updateBar(subtotalCents) {
    var el = document.querySelector('[data-joe-fs]');
    if (!el) return;

    var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 0;
    var msgEl = el.querySelector('[data-joe-fs-msg]');
    var fillEl = el.querySelector('[data-joe-fs-fill]');
    var textProgress = el.getAttribute('data-text-progress') || '';
    var textSuccess = el.getAttribute('data-text-success') || '';

    var remaining = threshold - subtotalCents;
    if (remaining < 0) remaining = 0;

    var pct = 0;
    if (threshold > 0) {
      pct = Math.min(100, Math.round((subtotalCents / threshold) * 100));
    }

    if (fillEl) fillEl.style.width = pct + '%';
    if (msgEl) {
      if (remaining <= 0 || threshold <= 0) {
        msgEl.innerHTML = boldify(textSuccess.split('[truck]').join(TRUCK_SVG));
      } else {
        msgEl.innerHTML = boldify(
          textProgress
            .replace('[amount]', formatMoney(remaining))
            .split('[truck]').join(TRUCK_SVG)
        );
      }
    }
  }

  function readSubtotal() {
    // The ajax cart appends a `.cart__items[data-cart-subtotal]` (cents) on every rebuild.
    // data-cart-fs-subtotal = le meme total MOINS les extras qui ne doivent pas compter pour
    // la livraison gratuite (protection de colis). On le prefere des qu'il est present.
    var items = document.querySelector('[data-products] .cart__items[data-cart-subtotal]');
    if (!items) return null;
    var fsSub = items.getAttribute('data-cart-fs-subtotal');
    if (fsSub !== null && fsSub !== '') return parseInt(fsSub, 10) || 0;
    return parseInt(items.getAttribute('data-cart-subtotal'), 10) || 0;
  }

  function init() {
    var el = document.querySelector('[data-joe-fs]');
    if (!el) return;

    var products = document.querySelector('#CartDrawerForm [data-products]') ||
                   document.querySelector('[data-products]');
    if (!products) return;

    var observer = new MutationObserver(function () {
      var sub = readSubtotal();
      if (sub !== null) updateBar(sub);
    });
    observer.observe(products, { childList: true, subtree: true });

    // Initial sync (in case cart already populated by ajax)
    var sub = readSubtotal();
    if (sub !== null) updateBar(sub);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* === JOE — Cart drawer : sous-total régulier (compare-at) barré, mise à jour live === */
(function () {
  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function update() {
    var itemsReg = document.querySelector('[data-products] .cart__items[data-cart-regular]');
    var itemsSub = document.querySelector('[data-products] .cart__items[data-cart-subtotal]');
    if (!itemsReg || !itemsSub) return;

    var regular = parseInt(itemsReg.getAttribute('data-cart-regular'), 10) || 0;
    var subtotal = parseInt(itemsSub.getAttribute('data-cart-subtotal'), 10) || 0;
    var onSale = regular > subtotal;

    // Sous-total régulier (barré)
    var target = document.querySelector('[data-joe-regular-subtotal]');
    if (target) {
      if (onSale) {
        target.textContent = formatMoney(regular);
        target.classList.remove('hide');
      } else {
        target.classList.add('hide');
      }
    }

    // Ligne "Vous économisez X (Y%)" sous le sous-total
    var savingsEl = document.querySelector('[data-joe-total-savings]');
    if (savingsEl) {
      if (onSale) {
        var saved = regular - subtotal;
        var pct = Math.round((saved * 100) / regular);
        var amtEl = savingsEl.querySelector('[data-joe-total-savings-amount]');
        var pctEl = savingsEl.querySelector('[data-joe-total-savings-pct]');
        if (amtEl) amtEl.textContent = formatMoney(saved);
        if (pctEl) pctEl.textContent = pct;
        savingsEl.classList.remove('hide');
      } else {
        savingsEl.classList.add('hide');
      }
    }
  }

  function init() {
    var products = document.querySelector('#CartDrawerForm [data-products]') ||
                   document.querySelector('[data-products]');
    if (!products) return;
    new MutationObserver(update).observe(products, { childList: true, subtree: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
